
import the404Img from "./404ErrorTwo.png"

const ErrorNotFound =({})=>{

    return(<>
      <div><img

      
        src={the404Img}
        alt=""
       style={{width:"320px"}
       }
       className={``}
      />
    <h2 style={{"textAlign":"center",margin:"15px",padding:"10px",borderRadius:"15px",background:"rgba(255,114,94,0.2)"
       
    }}>
        
         Opps... <span className="coloredTextV1">Not Found !!!</span> 
         
         
          <h6>
         
        <a target="_blank" href="https://storyset.com/online"style={{color:"#ffffff"}}>Online illustrations by Storyset</a>
        
       </h6>    </h2>
   </div> 

    </>)
}
export default ErrorNotFound;